export const PUSH_TO_ROUTEONE_REQUEST = 'PUSH_TO_ROUTEONE_REQUEST';
export const PUSH_TO_ROUTEONE_SUCCESS = 'PUSH_TO_ROUTEONE_SUCCESS';
export const PUSH_TO_ROUTEONE_FAILURE = 'PUSH_TO_ROUTEONE_FAILURE';
export const CONFIRM_PUSH_TO_ROUTEONE = 'CONFIRM_PUSH_TO_ROUTEONE';
export const UPDATE_PUSH_TO_ROUTEONE = 'UPDATE_PUSH_TO_ROUTEONE';
export const PUSH_TO_FI = 'PUSH_TO_FI';
export const PUSH_TO_ROUTEONE_STILL_WAITING = 'PUSH_TO_ROUTEONE_STILL_WAITING';
export const CLEAR_PUSH_TO_ROUTEONE_CACHE = 'CLEAR_PUSH_TO_ROUTEONE_CACHE';
